if (!customElements.get('bm-story')) {
  customElements.define('bm-story', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.dataset.enhanced = '';
      this.addEventListener('click', (event) => {
        const close = event.target.closest('[data-story-close]');
        if (close) {
          const details = close.closest('details');
          const summary = details.querySelector('summary');
          details.open = false;
          summary.focus({ preventScroll: true });
          requestAnimationFrame(() => {
            const top = summary.getBoundingClientRect().top;
            if (top < this.headerOffset() || top > innerHeight - 60) {
              window.scrollBy({ top: top - this.headerOffset() - 24, behavior: 'instant' });
            }
          });
        }
        const anchor = event.target.closest('a[href^="#"]');
        if (!anchor) return;
        const target = document.getElementById(anchor.hash.slice(1));
        if (!target) return;
        event.preventDefault();
        target.tabIndex = -1;
        target.focus({ preventScroll: true });
        window.scrollBy({ top: target.getBoundingClientRect().top - this.headerOffset() - 20, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }, options);
      this.querySelectorAll('.bm-story__film').forEach((details) => {
        details.addEventListener('toggle', () => {
          const video = details.querySelector('video');
          if (!video) return;
          if (details.open) video.play().catch(() => {});
          else video.pause();
        }, options);
      });
      document.addEventListener('shopify:block:select', (event) => {
        if (!this.contains(event.target)) return;
        const details = event.target.querySelector('details');
        if (details) details.open = true;
      }, options);
    }
    headerOffset() {
      return document.querySelector('header-component')?.getBoundingClientRect().height || 100;
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
